/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyAutocompleteResponseItem
 */
export interface AgencyAutocompleteResponseItem {
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof AgencyAutocompleteResponseItem
     */
    agency?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AgencyAutocompleteResponseItem
     */
    agencyGroup?: GuidIdAndLabel;
}

export function AgencyAutocompleteResponseItemFromJSON(json: any): AgencyAutocompleteResponseItem {
    return AgencyAutocompleteResponseItemFromJSONTyped(json, false);
}

export function AgencyAutocompleteResponseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyAutocompleteResponseItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'agency': !exists(json, 'agency') ? undefined : GuidIdCodeAndLabelFromJSON(json['agency']),
        'agencyGroup': !exists(json, 'agencyGroup') ? undefined : GuidIdAndLabelFromJSON(json['agencyGroup']),
    };
}

export function AgencyAutocompleteResponseItemToJSON(value?: AgencyAutocompleteResponseItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'agency': GuidIdCodeAndLabelToJSON(value.agency),
        'agencyGroup': GuidIdAndLabelToJSON(value.agencyGroup),
    };
}


